import { Box, Button, Checkbox, Grid, Stack, TextField, Typography } from '@mui/material';
import moment from 'moment-timezone';
import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loading from '../../../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { LanguageContext } from '../../../../../../../../libs/Context';
import { catchErr } from '../../../../../../../../libs/HelperContent';
import { CreateRegistration } from '../../../../../../../actions/meeting_actions';
import ImageBgView from '../PreviewLeft/Components/ImageBgView';
import CountDown from './Components/CountDown';
import Pending from './Components/Pending';
import ThankYou from './Components/ThankYou';

const PreviewRight = (props) =>
{
	const { data } = props;
	const userData = useSelector((state:any) => state.mysession.session);
	const name = new URLSearchParams(window.location.search).get('name') ?? '';
	const { language } = useContext(LanguageContext);
	const { id, type } = useParams();
	const imageSrc = data?.meetingDetails?.bannerImage?.length > 0 ? `${process.env.REACT_APP_S3_CLOUDFRONT}/${data?.meetingDetails?.bannerImage[0]?.key}` : '/images/icons/userregistration.svg';
	const today = new Date(data?.meetingDetails?.startTimeUTC);
	const webinarDate = new Date(today);
	const date = new Date(webinarDate).getDate();
	const monthYear = moment(webinarDate).format('MMM YYYY');
	const startTime = moment(webinarDate).format('hh:mm A');
	const endTime = moment(new Date(data?.meetingDetails?.endTimeUTC).valueOf()).format('hh:mm A');
	const [ component, setComponent ] = useState(type === 'waiting' ? 4 : 0);
	const [ loading, setLoading ] = useState(false);
	const [ input, setInput ] = useState({});
	const navigate = useNavigate();

	const handleInput = (e) =>
	{
		const key = e.target.id;
		const val = e.target.value;

		setInput((prev) => ({ ...prev, [key]: val }));
	};

	const HandleSubmit = async () =>
	{
		try
		{
			if (!loading)
			{
				setLoading(true);

				const body = {
					...input,
					sessionId  : id ? window.atob(id) : '',
					inviteType : 'mail'
				};

				const result = await CreateRegistration(body);

				if (result?.status)
				{
					toast.success('Registered successfully', {
						position  : toast.POSITION.TOP_RIGHT,
						className : 'toast-message'
					});

					setComponent(1);
					setLoading(false);
				}
				else
				{
					setLoading(false);
				}
			}
		}
		catch (err)
		{
			catchErr(err);
			setLoading(false);
		}
	};
	const renderObj = {
		1 : <Pending component={component} setComponent={setComponent} />,
		2 : <ThankYou component={component} setComponent={setComponent} />,
		3 : <CountDown targetDate={new Date().valueOf()} />
	};
	const webinarPathParam = userData?.userId === data?.scheduledBy ? 'join' : 'welcome';

	return (
		<>
			{loading && <Loading />}
			<Grid container flex={1}
				sx={{
					backgroundColor : 'var(--whiteColor)',
					borderRadius    : 'var(--pixel8)',
					width           : 'var(--percent100)',
					height          : 'var(--percent100)',
					flexWrap        : 'nowrap',
					flexDirection   : 'column'
				}}
			>
				<ImageBgView imgSrc={imageSrc} caption='Sample Caption' />
				<Grid item pb={3} mt={2}>
					<Typography textAlign={'center'} width={'var(--percent100)'} whiteSpace={'nowrap'} overflow={'hidden'} fontSize={'var(--pixel18)'} fontWeight='var(--font500)' textOverflow={'ellipsis'} px='var(--pixel8)'>{data?.meetingDetails?.meetingName ?? ''}</Typography>
					<Stack direction={'column'} alignItems={'center'}>
						<Stack direction={'row'} spacing={1} py='var(--pixel8)' alignItems={'center'}>
							<Grid sx={{ position: 'relative', display: 'flex', alignItems: 'flex-end' }} pr={'var(--pixel4)'}>
								<Box sx={{ width: '26px', height: '26px' }}><img src='/images/icons/calendericon.svg' alt='Calender-Icon' style={{ fontSize: 30 }} color='#979797'/></Box>
								<Typography
									variant='caption'
									style={{
										position   : 'absolute',
										top        : '55%',
										left       : '41%',
										transform  : 'translate(-50%, -50%)',
										fontWeight : 'bold',
										color      : '#979797'
									}}
								>
									{date}
								</Typography>
							</Grid>
							<Typography variant='body2' borderRight={'1px solid gray'} pr='var(--pixel8)' fontWeight='var(--font500)' lineHeight={'var(--pixel10)'}>{monthYear}</Typography>
							<Typography variant='body2' fontWeight='var(--font500)'>{startTime} - {endTime}</Typography>
						</Stack>
						{data?.meetingDetails?.startTimeUTC &&
						<CountDown targetDate={data?.meetingDetails?.startTimeUTC}/>}
					</Stack>
				</Grid>
				{(component === 0 || component === 4) &&
					<Grid item p='var(--pixel32)'>
						<Grid item pt='var(--pixel16)' width={'var(--percent100)'} display={'flex'} justifyContent={'center'} textAlign={'center'} flexDirection={'column'}>
							<Typography variant='h6' fontWeight='var(--font600)'>{ component === 4 ? name : language.registerevent}</Typography>
							<Typography fontSize={'var(--pixel12)'} py='var(--pixel8)'>
								{component === 4 ? 'Stay tuned ! The Webinar is about to start' : language?.fillFormRegster}
							</Typography>
							<Stack direction={'column'} display={'flex'} py='var(--pixel8)' justifyContent={'center'} spacing={2} width={'var(--percent100)'}>
								{component === 0 &&
								data?.meetingDetails?.registrationFields?.length > 0 &&
								data?.meetingDetails?.registrationFields?.map((item, ind) =>
									(
										<TextField
											key={`${item?.field} ${ind}`}
											id={`input${ind}`}
											label={`${item?.field}${item?.isRequired ? '*' : ''}`}
											variant='filled'
											value={input[`input${ind}`]}
											onChange={handleInput}
											size='small'
											sx={{
												'& .MuiFilledInput-root' : {
													backgroundColor : 'var(--lightGrayf6)'
												},
												'& .MuiFilledInput-root:hover' : {
													backgroundColor : 'var(--lightGrayf6)'
												},
												'& .MuiFilledInput-root.Mui-focused' : {
													backgroundColor : 'var(--lightGrayf6)'
												}
											}}
										/>
									)
								)}
								{component === 0 &&
								<Stack direction='row' alignItems='center' my='var(--pixel8)'>
									<Checkbox />
									<Typography variant='body2'>
										{language?.acceptTerms}
										<Typography component={'span'} color={'primary'} sx={{ cursor: 'pointer' }} variant='body2'>
											{language?.termsConditionss}
										</Typography>
									</Typography>

								</Stack>}
								<Stack direction={'row'} alignItems={'center'} justifyContent={'center'} pt='var(--pixel16)'>
									<Button
										style={{
											width         : '60%',
											color         : 'white',
											opacity       : component === 4 && (data?.startTime <= new Date().valueOf()) ? '' : '0.5',
											pointerEvents : component === 4 && (data?.startTime <= new Date().valueOf()) ? 'auto' : 'none'
										}}
										variant='contained'
										onClick={() =>
										{
											component !== 4 && (data?.startTime <= new Date().valueOf())
												? navigate(`/webinarsvc/${webinarPathParam}/${window.btoa(data?._id)}&email=${window.btoa(userData?.email)}`)
												: HandleSubmit();
										}}
										disabled={component === 4 &&
											(data?.startTime <= new Date().valueOf())}
									>
										{component === 4 ? 'Join Webinar' : language.register}
									</Button>
								</Stack>
							</Stack>
						</Grid>
					</Grid>
				}
				{renderObj[component] || null}
			</Grid>
		</>

	);
};

export default PreviewRight;